import { useEffect, useState } from 'react';

const useGetMimesisStepEngineUrl = (): string => {
  const [mimesisStepEngineRelativeUrl, setMimesisStepEngineRelativeUrl] =
    useState('');

  const getMimesisStepEngineUrl = async () => {
    const url = await window.dsDesktop?.app.getMimesisEngineStepUrl();

    setMimesisStepEngineRelativeUrl(url);
  };

  useEffect(() => {
    getMimesisStepEngineUrl().catch(console.error);
  }, []);

  return mimesisStepEngineRelativeUrl;
};

export default useGetMimesisStepEngineUrl;
